import { combineReducers } from 'redux'

import error from './error'
import loading from './loading'
import success from './success'
import end from './end'

export default combineReducers({
  error,
  loading,
  success,
  end,
})
